<button class="widget-button" [class.broker-widget-btn]="isBrokerFlow" appHelpWidget [isBrokerFlow]="isBrokerFlow" (widgetOpen)="onWidgetOpen($event)" (chatMinimized)="onChatMinimize($event)" (chatSDKReady)="onChatSDKReady($event)">
    <span class="hidden-xs">
        <span [innerHTML]="'Widget.ButtonText' | translate | punctuationWrap"></span>
        <app-icon [icon]="Icon.Arrow"></app-icon>
    </span>
    <div id="widgetbtn_json" class="lottie visible-xs" style="width:44px; height:44px;"></div>
</button>
<div *ngIf ="isBrokerFlow" class="widget-container broker-widget">
    <div class="widget-header">
        <div class="search-logo">
            <i *ngIf ="!selectedBrokerInfo" [illustration]="illustration.FindBrokerHandshake"></i>
            <i *ngIf ="selectedBrokerInfo" [illustration]="illustration.BrokerHandshake"></i>
        </div>
        <div class="search-explanation" >
            <div class="search-info" *ngIf ="selectedBrokerInfo && isKnownBrokerFlow">
                <p [innerHTML]="'Widget.Broker.KnownBrokerTitle' | translate | punctuationWrap"></p>
                <p [innerHTML]="'Widget.Broker.KnownBrokerTitleDesc' | translate | punctuationWrap"></p>
            </div>
            <div class="search-info" *ngIf ="!selectedBrokerInfo && !isKnownBrokerFlow">
                <p [innerHTML]="'Widget.Broker.UnKnownBrokerTitle' | translate | punctuationWrap"></p>
                <p [innerHTML]="'Widget.Broker.UnKnownBrokerTitleDesc' | translate | punctuationWrap"></p>
            </div>
            <div class="search-info" *ngIf ="selectedBrokerInfo && !isKnownBrokerFlow">
                <p [innerHTML]="'Widget.Broker.UnKnownBrokerTitleAfterSelection' | translate | punctuationWrap"></p>
                <p [innerHTML]="'Widget.Broker.UnKnownBrokerTitleDescAfterSelection' | translate | punctuationWrap"></p>
            </div>
            <div class="search-btn" *ngIf="!selectedBrokerInfo">
                <button class="btn btn-primary" (click)="searchBroker(false)" [innerHTML]="'Widget.Broker.UnKnownBrokerCTA' | translate | punctuationWrap"></button>
            </div>
        </div>
    </div>
    <div class= "broker-info-container" *ngIf="selectedBrokerInfo  && !isKnownBrokerFlow">
        <div class="broker-details">
            <div class="name-BCE">
                <h3 class="selected-broker-name" *ngIf="selectedBrokerInfo">{{selectedBrokerInfo.name}}</h3>
                <p class="selected-broker-bce" *ngIf="selectedBrokerInfo.bce"><span [innerHTML]="'Widget.Broker.BrokerReference' | translate | punctuationWrap"></span>&nbsp;&nbsp;{{selectedBrokerInfo.bce}}</p>
            </div>
            <div class="selected-broker-img hidden-xs" *ngIf="selectedBrokerInfo.logoUrl">
                <img src="{{this.brokerLogoCustomChange}}" alt="Broker Logo" class="pull-right">
            </div>
        </div>
        <div class="info-item" *ngIf = "this.selectedBrokerInfo.address">
            <app-icon [icon]="Icon.LocationPin"></app-icon>
            <div class="info-item-text"><a class="btn-link broker-address-link" href="http://maps.google.com/maps?q={{selectedBrokerInfo.address.street}}+{{selectedBrokerInfo.address.number}}+{{selectedBrokerInfo.address.zip}}+{{selectedBrokerInfo.address.city}}" target="_blank">{{selectedBrokerInfo.address.street}} {{selectedBrokerInfo.address.number}} {{selectedBrokerInfo.address.zip}} {{selectedBrokerInfo.address.city}}</a></div>
        </div>
        <ng-container *ngIf = "selectedBrokerInfo.brokerPublicCommunications && selectedBrokerInfo.brokerPublicCommunications.length">
            <div class="info-item" *ngIf = "selectedBrokerInfo.brokerPublicCommunications[0].Phone?.Value">
                <app-icon [icon]="Icon.Phone"></app-icon>
                <div class="info-item-text  phone-number"><a class="btn-link broker-telephone-link" href="tel:{{selectedBrokerInfo.brokerPublicCommunications[0].Phone?.Value}}" target="_blank">{{selectedBrokerInfo.brokerPublicCommunications[0].Phone?.Value}}</a></div>
            </div>

            <div class="info-item" *ngIf = "selectedBrokerInfo.brokerPublicCommunications[0].Email?.Value">
                <app-icon [icon]="Icon.EmailUnread"></app-icon>
                <div class="info-item-text" ><a class="btn-link" href="mailto:{{selectedBrokerInfo.brokerPublicCommunications[0].Email?.Value}}">{{selectedBrokerInfo.brokerPublicCommunications[0].Email?.Value}}</a></div>
            </div>
        </ng-container>

        <div class="info-item" *ngIf = "selectedBrokerInfo.websiteUrl">
            <app-icon [icon]="Icon.WebsiteGlobe"></app-icon>
            <div class="info-item-text" ><a class="btn-link" href="https://{{selectedBrokerInfo.websiteUrl}}" target="_blank">{{selectedBrokerInfo.websiteUrl}}</a></div>
        </div>
        <div class="info-item broker-logo-xs visible-xs" *ngIf="selectedBrokerInfo.logoUrl">
            <img src="{{this.brokerLogoCustomChange}}" alt="Broker Logo">
        </div>
        <div class="change-broker-section">
            <div class="change-btn-wrapper">
                <!-- <p>Not the one you that suits you?</p> -->
                <button class="btn btn-secondary" (click)="searchBroker(false)" [innerHTML]="'Widget.Broker.UnKnownBrokerChangeSelectionCTA' | translate | punctuationWrap"></button>
            </div>
        </div>
    </div>
    <div class= "broker-info-container" *ngIf="selectedBrokerInfo && isKnownBrokerFlow">
        <div class="broker-details">
            <div class="name-BCE">
                <h3 class="selected-broker-name" *ngIf="selectedBrokerInfo">{{selectedBrokerInfo.Name}}</h3>
                <p class="selected-broker-bce" *ngIf="selectedBrokerInfo.Bce"><span [innerHTML]="'Widget.Broker.BrokerReference' | translate | punctuationWrap"></span>&nbsp;&nbsp;{{selectedBrokerInfo.Bce}}</p>
            </div>
            <div class="selected-broker-img hidden-xs" *ngIf="selectedBrokerInfo.BrokerLogoUrl">
                <img src="{{selectedBrokerInfo.BrokerLogoUrl}}" alt="Broker Logo" class="pull-right">
            </div>
        </div>
        <div class="info-item" *ngIf = "this.selectedBrokerInfo.BrokerAddress">
            <app-icon [icon]="Icon.LocationPin"></app-icon>
            <div class="info-item-text"><a class="btn-link broker-address-link" href="http://maps.google.com/maps?q={{selectedBrokerInfo.BrokerAddress.Street}}+{{selectedBrokerInfo.BrokerAddress.Number}}+{{selectedBrokerInfo.BrokerAddress.Zip}}+{{selectedBrokerInfo.BrokerAddress.City}}" target="_blank">{{selectedBrokerInfo.BrokerAddress.Street}} {{selectedBrokerInfo.BrokerAddress.Number}} {{selectedBrokerInfo.BrokerAddress.Zip}} {{selectedBrokerInfo.BrokerAddress.City}}</a></div>
        </div>
        <ng-container *ngIf = "selectedBrokerInfo.BrokerCommunications && selectedBrokerInfo.BrokerCommunications.length">
            <div class="info-item" *ngIf = "selectedBrokerInfo.BrokerCommunications[0].Phone">
                <app-icon [icon]="Icon.Phone"></app-icon>
                <div class="info-item-text  phone-number"><a class="btn-link broker-telephone-link" href="tel:{{selectedBrokerInfo.BrokerCommunications[0].Phone}}" target="_blank">{{selectedBrokerInfo.BrokerCommunications[0].Phone}}</a></div>
            </div>

            <div class="info-item" *ngIf = "selectedBrokerInfo.BrokerCommunications[0].Email">
                <app-icon [icon]="Icon.EmailUnread"></app-icon>
                <div class="info-item-text" ><a class="btn-link" href="mailto:{{selectedBrokerInfo.BrokerCommunications[0].Email}}">{{selectedBrokerInfo.BrokerCommunications[0].Email}}</a></div>
            </div>
        </ng-container>

        <div class="info-item" *ngIf = "selectedBrokerInfo.WebsiteUrl">
            <app-icon [icon]="Icon.WebsiteGlobe"></app-icon>
            <div class="info-item-text" ><a class="btn-link" href="https://{{selectedBrokerInfo.WebsiteUrl}}" target="_blank">{{selectedBrokerInfo.WebsiteUrl}}</a></div>
        </div>
        <div class="info-item broker-logo-xs visible-xs" *ngIf="selectedBrokerInfo.BrokerLogoUrl">
            <img src="{{selectedBrokerInfo.BrokerLogoUrl}}" alt="Broker Logo">
        </div>        
    </div>
</div>


<div *ngIf ="!isBrokerFlow" class="widget-container digital-container">
    <div class="digital-header">
        <div [innerHTML]="'Widget.Digital.Title' | translate | punctuationWrap"></div>
        <div [innerHTML]="'Widget.Digital.SubTitle' | translate:{ signature: signature } | punctuationWrap"></div>
    </div>
    <div class= "digitals-info-container">
        <div class="communication-container">
            <a class="info-item" href="tel:{{'Widget.Digital.TelNumber' | translate}}" target="_blank">
                <i [illustration]="illustration.ContactPhone"></i>
                <div class="info-item-text" [innerHTML]="'Widget.Digital.PhoneNumber' | translate | punctuationWrap"></div>
                <div class="info-item-text right-content">
                    <div [innerHTML]="'Widget.Digital.PhoneText' | translate | punctuationWrap"></div>
                    <div class="call-time" [innerHTML]="'Widget.Digital.PhoneTimePart1' | translate"></div>
                    <div class="call-time" [innerHTML]="'Widget.Digital.PhoneTimePart2' | translate"></div>
                </div>
            </a>
           <!--  <div class="info-item chat-item" *ngIf="isAgentAvailable && isChatSDKReady" (click)="openChat()">
                <i [illustration]="illustration.ContactChat"></i>
                <div class="info-item-text chat" [innerHTML]="'Widget.Digital.Chat' | translate | punctuationWrap"></div>
                <div class="right-content available">
                    <div>
                        <span [innerHTML]="'Widget.Digital.Available' | translate | punctuationWrap"></span>
                        <span class="online"></span>
                    </div>
                </div>
            </div> -->
            <a class="info-item"  href="mailto:{{ email }}" target="_blank">
                <i [illustration]="illustration.ContactEmail"></i>
                <div class="info-item-text" >{{ email }}</div>
            </a>
        </div>
    </div>
   <!--  <div class="minimized-chat-button" *ngIf="isChatMinimised && isAgentAvailable">
        <div class="chat-close-button" (click)="closeChat()">
            <i [illustration]="illustration.Close"></i>
        </div>
        <div class="minimized-icon" (click)="openChat()">
            <i [illustration]="illustration.Communication"></i>
        </div>
    </div> -->
</div>

<app-modal #brokerModal [strictClose]="true" [customClass]="'broker-tool-modal'" title="{{ 'Simulation.BrokerSearch.BrokerSearch_Modal_title' | translate }}" buttonText="{{ 'Simulation.BrokerSearch.BrokerSearch_Modal_button' | translate }}" [isPrimaryButton]="false" [showButton]="false" (toggleModal)="onBrokerToolToogle($event)">
    <div class="broker-tool-wrapper">
        <ng-container #brokerToolContainerFromWidget></ng-container>
    </div>
</app-modal>
